import { brand, BrandC, Branded, Type } from "io-ts"
import { Predicate } from "fp-ts/Predicate"

export type BrandFor<N extends string> = {
    readonly [K in N]: symbol
}

export const brandFromPredicate = <N extends string, A, O, I>(
    type: Type<A, O, I>,
    predicate: Predicate<A>,
    name: N,
): BrandC<Type<A, O, I>, BrandFor<N>> => brand(type, (x: A): x is Branded<A, BrandFor<N>> => predicate(x), name)
